window.addEventListener( "DOMContentLoaded", function()
{
    var images = document.querySelectorAll( ".edge-article-content .edge-article-text table img" );
    var markup;

    if( images && images.length )
    {
        for( var i = 0; i < images.length; i++ )
        {
            // var image = images[ i ];
            // if( markup == undefined )
            // {
            //     markup = "<div><a href=" + image.src + " data-fancybox='gallery' >" + "<img loading="lazy" src=" + image.src + "/></a></div>"
            // }
            // else
            // {
            //     markup = markup + "<div><a href=" + image.src + " data-fancybox='gallery' >" + "<img loading="lazy" src=" + image.src + "/></a></div>"
            // }
    
            if( i == ( images.length - 1 ) )
            {
                document.querySelector( ".edge-article-other-imgs-container" ).innerHTML = markup;
    
                window.setTimeout( function()
                {
                    $('.edge-article-more-news-container').slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        prevArrow: ".related-articles .prev",
                        nextArrow: ".related-articles .next",
                        responsive: [
                          {
                            breakpoint: 769,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          }
                        ]
                      });
                  
                      $('.edge-article-other-imgs-container').slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true,
                        prevArrow: ".edge-article-related-content .prev",
                        nextArrow: ".edge-article-related-content .next",
                        responsive: [
                          {
                            breakpoint: 769,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          }
                        ]
                      });
                }, 1000 )
            }
    
            image.parentNode.removeChild( image );
        }

        $('.edge-article-other-imgs-container').slick("unslick");
        $('.edge-article-more-news-container').slick("unslick");
    }
    else
    {
        var markup;

        var defaultImages = document.querySelectorAll( ".edge-default-other-imgs" );
      	var container		= document.querySelector( ".edge-article-other-imgs-container" );
        var markup;
      
        for( var i = 0; i < defaultImages.length; i++ )
        {
            var defaultImage    = defaultImages[ i ];
            var copy            = defaultImage.cloneNode( true );
            copy.classList.remove( "edge-default-other-imgs" );
			
          	if( container )
            {
                container.appendChild( copy ); 
            }
        }
    }
    $('.edge-article-more-news-container').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: ".custom-arrow .prev",
        nextArrow: ".custom-arrow .next",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 1,
              adaptiveHeight: true
            }
          }

        ]
      });

      $('.edge-article-trending-news-container').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: ".custom-trending-arrow .prev",
        nextArrow: ".custom-trending-arrow .next",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 1,
              adaptiveHeight: true
            }
          }

        ]
      });
  
      $('.edge-article-other-imgs-container').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: ".edge-article-related-content .prev",
        nextArrow: ".edge-article-related-content .next",
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

} );